import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { Box } from '@gemini/core';
import { TextField } from '@gemini/ui';
import { useFormContext, useWatch } from 'react-hook-form';

import { NAME_SPACE } from '@/frontend/src/hooks/useLoadTranslations';

type TProps = {
    name: string;
};

const ClosestLocationSearchField = ({ name }: TProps) => {
    const { t } = useTranslation(NAME_SPACE);
    const { setValue, clearErrors, control, getFieldState } = useFormContext();

    const onChange = (value: string) => {
        setValue(name, value);

        clearErrors(name);
    };

    return (
        <Box gridArea={name}>
            <TextField
                name={name}
                isFullWidth
                isOptional={name === 'houseNumber'}
                label={t(`common.fields.${name}.label`)}
                defaultValue={useWatch({ control, name })}
                onChange={onChange}
                hasNecessityIndicator={false}
                error={getFieldState(name).error?.message}
            />
        </Box>
    );
};

export default ClosestLocationSearchField;
